module.exports = __webpack_public_path__ + "static/media/Forthnet_Group.76e2f7ae.png";